"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _material = require("@mui/material");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _wouter = require("wouter");
var _Style = require("../../style/Style");
var _form = require("../../components/form");
var _common = require("../../store/common");
var _course = require("../../store/course");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = props => {
  const [, setLocation] = (0, _wouter.useLocation)();
  const {
    setToastOpen,
    setToastText,
    setIsLoading,
    setLoadingMessage
  } = (0, _common.useCommonStore)();
  const {
    setCurrentCourse,
    checkCurrentCourse,
    addCurrentCourse,
    updateCurrentCourse,
    setCurrentCourseById,
    initCurrentCourse,
    currentCourse,
    errors,
    submitting
  } = (0, _course.useCourseStore)();
  const [isUpdate] = (0, _react.useState)(!!props.id);
  const detailRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    (async () => {
      if (!props.id) {
        initCurrentCourse();
        return;
      }
      setIsLoading(true);
      await setCurrentCourseById(props.id);
      setIsLoading(false);
    })();
  }, []);
  const onLoadingTextChanged = text => {
    setLoadingMessage(text);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    ...stylex.props(_Style.wrapper.main),
    spacing: 4,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
        ...stylex.props(_Style.buttonStyle.secondary),
        onClick: () => {
          setLocation('/course');
        },
        children: "\uFF1C\u623B\u308B"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
      container: true,
      ...stylex.props(_Style.wrapper.mainTitle),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.h1),
        children: "\u30B3\u30FC\u30B9\u8FFD\u52A0"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      spacing: 2,
      direction: 'column',
      ...stylex.props(_Style.wrapper.stretchW),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldInput, {
        label: "\u30B3\u30FC\u30B9\u540D",
        type: "text",
        value: currentCourse.name,
        errorText: errors.name,
        placeholder: 'コースの名前を入力してください(他のコースと重複不可)',
        onChange: event => {
          setCurrentCourse({
            name: event.target.value
          });
        },
        onEnterKey: () => {
          var _detailRef$current;
          (_detailRef$current = detailRef.current) === null || _detailRef$current === void 0 ? void 0 : _detailRef$current.focus();
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldTextArea, {
        label: "\u30B3\u30FC\u30B9\u6982\u8981",
        type: "textarea",
        value: currentCourse.detail,
        onChange: event => {
          setCurrentCourse({
            detail: event.target.value
          });
        },
        errorText: errors.detail,
        placeholder: 'コースの概要を入力してください'
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_form.FormFieldImage, {
        label: "\u30B5\u30E0\u30CD\u30A4\u30EB\u753B\u50CF",
        type: "file",
        previewUrl: currentCourse.thumbnailPreviewUrl,
        onChange: event => {
          const target = event.target;
          if (!target.files || target.files.length === 0) return;
          const file = target.files[0];
          if (!file) return;
          setCurrentCourse({
            thumbnailFile: file
          });
        },
        errorText: errors.thumbnailFile
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        ...stylex.props(_Style.buttonStyle.primary),
        disabled: submitting,
        onClick: async () => {
          setIsLoading(true);
          if (!(await checkCurrentCourse(isUpdate))) {
            setIsLoading(false);
            return;
          }
          setIsLoading(false);
          if (!window.confirm((isUpdate ? 'コース内容を変更' : 'コースを追加') + 'しますか？')) {
            return;
          }
          setIsLoading(true);
          const result = isUpdate ? await updateCurrentCourse(onLoadingTextChanged) : await addCurrentCourse(onLoadingTextChanged);
          if (!result) {
            setIsLoading(false);
            return;
          }
          setToastOpen(true);
          setToastText(isUpdate ? 'コース内容を変更しました' : 'コースを追加しました');
          setLocation('/');
          setIsLoading(false);
          return;
        },
        children: [submitting ? isUpdate ? 'コース内容変更中...' : 'コース追加中...' : isUpdate ? 'コース内容を変更する' : 'コース追加する', submitting && "DEBUG"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Grid2, {
        minHeight: 48,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props(_Style.textStyle.error),
          children: errors.submit
        })
      })]
    })]
  });
};
var _default = exports.default = App;